import Question from './question';
import * as constants from '../constants';
import ChartTool from '../tools/chart/chart-tool';

export default class ChartQuestion extends Question {
  /**
   * @property {PIXI.Point} answer
   */

  /**
   * @constructor
   * @param {Object}  [config]
   * @param {boolean} [config.axisLabels]
   * @param {string}  [config.showNums] - 'all','none','intersection'
   */
  constructor({ axisLabels, showNums } = {}) {
    super(...arguments);

    if ( typeof showNums === 'undefined' ) {
      showNums = [ 'intersection', 'all', 'none' ][ Math.floor(3 * Math.random()) ];
    }

    if ( typeof axisLabels === 'undefined' ) {
      axisLabels = showNums === 'all' && Math.random() < 0.5 ? false : true;
    }

    this.config.axisLabels = axisLabels;
    this.config.showNums = showNums;
  }

  get tool() {
    return ChartTool;
  }
  get title() {
    return `Select ${ this.multiplicand } ${ constants.multiplicationSign } ${ this.multiplier }`;
  }
  get result() {
    return !!this.answer && (
      ( this.answer.x === this.multiplicand && this.answer.y === this.multiplier ) ||
      ( this.answer.x === this.multiplier && this.answer.y === this.multiplicand )
    );
  }
  get axisLabels() {
    return this.config.axisLabels;
  }
  get showNums() {
    return this.config.showNums;
  }

  correctSolution() {
    return new PIXI.Point(this.multiplicand, this.multiplier);
  }
}
